import { Injectable } from '@angular/core';

@Injectable()
export class ExportOptionsHelper {
  exportOptions = {
    removeRemoteIds: true,
  };
}
